import DadosCadastrais from "../DadosCadastrais";
import { TabsClientes } from "core/features/clientes-tenant/data/TabsClientes";
import { TenantDetalhe } from "core/features/tenants/typings/tenant";

function ClientesTabs({
  id,
  tenantId,
  tabActive,
  tenant,
  onSubmitSuccess,
}: {
  id?: string;
  tenantId?: string;
  tabActive: TabsClientes;
  tenant?: TenantDetalhe;
  onSubmitSuccess: (id: string) => void;
}) {
  const enableEditOptions = !!id || !!tenantId;
  const _tenantId = id || tenantId;

  return (
    <>
      {tabActive === TabsClientes.Dados ? (
        <DadosCadastrais
          tenantId={_tenantId}
          onSubmitSuccess={(result) => onSubmitSuccess(result)}
          isEdit={enableEditOptions}
          defaultData={tenant}
          tipoTenantId={tenant?.tipoTenantId!}
        />
      ) : null}
    </>
  );
}

export default ClientesTabs;
